import React, { Component } from 'react';
import { Checkbox} from 'antd';
import intl from 'react-intl-universal';
import './index.scss';

export default class JavaScript extends Component {

    constructor(props){
        super(props);
        this.state = {
            isJSEnable: true
        }
    }

    componentDidMount(){
        let enableFlag = localStorage.getItem('enable_js_action');
        if (enableFlag === null || enableFlag === undefined) {
            enableFlag = window.pdfui.pdfViewer.getEnableJS();
        }
        if(typeof enableFlag === 'string'){
            enableFlag = enableFlag === 'true' ? true : false;
        }

        this.setState({isJSEnable: enableFlag})
    }

    enableJavascriptActions(e){
        const {checked} = e.target;
        this.setState({isJSEnable:checked});
        window.pdfui.eventEmitter.emit('js_action_event_pre',checked);
    }
    render() {
        const isJSEnable = this.state.isJSEnable
        return (
            <div className="preferences-javascript">            
                <div className="title">{intl.formatMessage({ id: 'Preferences.Content.JavaScript.Title' })}</div>
                <div className="board">
                    <Checkbox className="ckb" checked={isJSEnable} onChange={(e)=>{this.enableJavascriptActions(e)}}>
                        { intl.formatMessage({ id: 'Preferences.Content.JavaScript.EnableActions' }) }
                    </Checkbox>
                </div>
            </div>
        )
    }
}
